import { Roles } from '@cod-monorepo/interfaces';
import { SideBarItem } from './model/side-bar-item.model';

export const sideBarItems: SideBarItem[] = [
    {
        routerLink: '/',
        tooltip: 'Dashboard',
        icon: 'apps'
    },
    {
        routerLink: '/cod/create',
        tooltip: 'Create COD',
        icon: 'plus-large'
    },
    {
        routerLink: '/report',
        tooltip: 'Report',
        icon: 'chart-pie',
        roles: [Roles.ADMIN, Roles.REPORTING]
    },
    {
        routerLink: '/user-management',
        tooltip: 'User Management',
        icon: 'user',
        roles: [Roles.ADMIN]
    }
] as const;

export const bottomSideBarItems: SideBarItem[] = [] as const;
